import {useQuery} from '@tanstack/react-query';
import axiosClient from '../services/axiosClient';

export const useGetDashboardAnalyticsQuery = () => {
  return useQuery(['dashboard'], async () => {
    const {data} = await axiosClient.get('account/user/dashboard');
    return data;
  });
};
